import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';

import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-race-conditions',
  templateUrl: './race-conditions.component.html',
  styleUrls: ['./race-conditions.component.scss']
})
export class RaceConditionsComponent implements OnInit {

  @Input() race;
  @Input() fixture;
  conditions: any;
  going: any;
  declarationGoing: any;
  meta: {
    loading: boolean,
    showDifferences: boolean,
    declarationNotFound: boolean
  };

  constructor(
    public activeModal: NgbActiveModal,
    private notification: ToastrService,
    private apiService: ApisService
  ) { }

  ngOnInit() {
    this.meta = {
      loading: false,
      showDifferences: false,
      declarationNotFound: false
    };
    this.getRaceConditions();
  }

  switchMode(forceToValue) {
    if (forceToValue === undefined) {
      this.meta.showDifferences = !this.meta.showDifferences;
    } else {
      this.meta.showDifferences = forceToValue;
    }

  }

  getRaceConditions() {
    this.meta.loading = true;
    this.apiService.getRaceConditions(this.race.yearOfRace, this.race.raceId, this.race.divisionSequence).subscribe(
      res => {
        this.conditions = res;
        this.going = res.going ? res.going.map(going => going) : [];
        delete res.going;

        this.conditions.raceTime = moment(this.conditions.raceDateTime).format('H:mm A');
        this.conditions.raceFullDate = moment(this.conditions.raceDateTime).format('dddd, DD MMMM YYYY');

        this.going.forEach(going => {
          going.data.conditions.groundDescription = this.apiService
            .getGroundDescription(going.data.conditions.ground).label;
          going.data.conditions.conditionInPlacesDescription = this.apiService
            .getGroundDescription(going.data.conditions.conditionInPlaces).label;
          going.data.tracks.forEach(track => {
            track.available = track.ground || track.conditionInPlaces || track.goingStickAvailable ? true : false;
            track.groundDescription = this.apiService.getGroundDescription(track.ground).label;
            track.conditionInPlacesDescription = this.apiService.getGroundDescription(track.conditionInPlaces).label;
          });
          going.data.tracks = going.data.tracks.filter(t => t.available);
        });

        const declarationGoingIndex = this.going.findIndex(going =>
          moment(going.creationTimestamp).isBefore(moment(this.conditions.overnightDate))
        );
        if (declarationGoingIndex !== -1) {
          this.going[declarationGoingIndex].declarationGoing = true;
          this.declarationGoing = this.going[declarationGoingIndex];
          this.meta.declarationNotFound = false;
        } else {
          this.meta.declarationNotFound = true;
          // this.going[this.going.length - 1].declarationGoing = true;
          // this.declarationGoing = this.going[this.going.length - 1];
        }

        // console.log(this.going);
        this.meta.loading = false;
      },
      err => {
        console.error('[ DEBUG ] Error loading race conditions', err);
        this.notification.error(`Could't get the race conditions. Check your connection and Try again.`, 'Race Conditions');
        this.meta.loading = false;
      }
    );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }

}
